<span
  [ngClass]="{ 'icon-open': rotate === '180', 'icon-close': rotate == null }"
  class="icon {{ set }} {{ set }}-{{ name }}"
></span>
